import React from "react";
import t from "../../i18n";
import { useCanUserDo, useCanUserDoOnSomeProject } from "../canUserDo";
import NavV2 from "@ui/NavV2";
import Tab from "@ui/NavV2/Tab";
import { useLocation } from "react-router";
import { toPath } from "../../router/helpers/path";

export const AdministrationNavigation = () => {
  const location = useLocation();
  const isUserAdminUserManager = useCanUserDo("ADMIN_USER_MANAGE");
  const isUserUserManager = useCanUserDoOnSomeProject("USER_MANAGE");
  const isAdminSettingsManager = useCanUserDo("ADMIN_SETTING_MANAGE");
  const canManageProcesses = useCanUserDo("PROCESS_MANAGE");
  const hasProjectEditGlobalPermission = useCanUserDo("CATEGORY_READ");

  const links = React.useMemo(
    () => (
      <>
        {(isUserAdminUserManager || isUserUserManager) && (
          <Tab theme="dark" to={toPath("/administration/users", {})} data-cy="users-tab">
            {t("administration.header.users")}
          </Tab>
        )}
        {isAdminSettingsManager && (
          <Tab
            theme="dark"
            to={toPath("/administration/customization", {})}
            data-cy="customization-tab"
          >
            {t("administration.header.customization")}
          </Tab>
        )}
        {canManageProcesses && (
          <Tab theme="dark" to={toPath("/administration/processes", {})} data-cy="processes-tab">
            {t("administration.header.processes")}
          </Tab>
        )}
        {hasProjectEditGlobalPermission && (
          <Tab
            theme="dark"
            to={toPath("/administration/classification/quantities", {})}
            data-cy="classification-tab"
            active={location.pathname.includes("classification")}
          >
            {t("administration.header.classification")}
          </Tab>
        )}
      </>
    ),
    [
      isUserAdminUserManager,
      isUserUserManager,
      isAdminSettingsManager,
      canManageProcesses,
      hasProjectEditGlobalPermission,
      location.pathname,
    ],
  );
  return <NavV2>{links}</NavV2>;
};
